import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import ActionButton from "../Shared/ActionButton";
import { LoadingIcon } from "@prosolve/common-components-ui";

export default function RunOrderNoficiationButton() {
  const fetch = useFetch()
  
  const [isBusy, setIsBusy] = useState(false)

  const fetchRunOrderNoficiations = async () => {
    setIsBusy(true)
    const result = await fetch('shipping/email/notifications', { method: 'POST' })
    const json = await result.json()
    alert(
`The following emails have been sent:

OrderCreatedEmails: ${json.orderCreatedEmails?.length}
OrderDeliveredEmails: ${json.orderDeliveredEmails?.length}`
    )
    setIsBusy(false)
  }

  const runOrderNotifications = () => {
    if (window.confirm('Are you sure you want to run the order notifications? \n\n(Currently, emails will be sent only to Paul, and you will receive a summary of how many were sent)')) {
      fetchRunOrderNoficiations()
    }
  }

  return (
    <ActionButton onClick={runOrderNotifications} $disabled={isBusy}>
      Run Order Notifications 
      {isBusy && <span style={{ paddingLeft: '10px'}}><LoadingIcon /></span>}
    </ActionButton>
  )
}